module.exports = __webpack_public_path__ + "img/rectangle-list.3fb975d7.svg";